import { HttpClient } from 'api/http-client';
import {
  AiFillApp,
  AiFillAppDestination,
  AiFillAppInput,
  AiFillConfig,
  AiFillRuntimeInput,
  CustomAiFillApp,
  ResolveAppParams,
  SourceForResolvingApp,
} from './types';

class AIFillAppClient extends HttpClient {
  public getAIFillApps = (): Promise<AiFillApp[]> =>
    this.get<AiFillApp[]>('/aifill?destination=DOCUMENT');

  public createAIFillApp = (appConfig: AiFillConfig): Promise<AiFillApp> =>
    this.post('/aifill', {
      aiFillAppConfig: appConfig,
      allowedInputs: [AiFillAppInput.Meeting],
      allowedDestinations: [
        AiFillAppDestination.Document,
        AiFillAppDestination.DocumentTemplate,
        AiFillAppDestination.ProjectUpdate,
      ],
    });

  public updateAIFillApp = (
    app: CustomAiFillApp,
    updatedConfig: AiFillConfig,
  ): Promise<AiFillApp> =>
    this.put(`/aifill/${app.aiFillAppId}`, {
      ...app,
      aiFillAppConfig: updatedConfig,
    });

  public deleteAIFillApp = (app: CustomAiFillApp): Promise<void> =>
    this.delete(`/aifill/${app.aiFillAppId}`);

  public streamContentForDefaultAIFillApp = ({
    appId,
    sources,
    onContentReceived,
    destination,
  }: ResolveAppParams): Promise<string> =>
    this.post<{ sources: SourceForResolvingApp[] }, unknown, string>(
      `aifill/resolve/stream?app=${appId}`,
      { sources, destination },
      {
        onDownloadProgress: (e) => {
          onContentReceived(e.event?.target?.response);
        },
      },
    );

  public streamContentForCustomAIFillApp = ({
    appId,
    sources,
    destination,
    onContentReceived,
  }: ResolveAppParams): Promise<string> =>
    this.post<{ sources: SourceForResolvingApp[] }, unknown, string>(
      `aifill/${appId}/resolve`,
      { sources, destination },
      {
        onDownloadProgress: (e) => {
          onContentReceived(e.event?.target?.response);
        },
      },
    );

  public async aiFillResolveStatusUpdate(
    statusUpdateId: number,
    data: AiFillRuntimeInput,
  ): Promise<void> {
    return this.post(`/aifill/status-updates/${statusUpdateId}/resolve`, data);
  }
}

export const AIFillAppAPI = new AIFillAppClient();
